import React, { useEffect, useState } from 'react';
import { CurrencyInput } from './CurrencyInput';
import { formatCurrency } from '../utils/currency';

export function PaymentStructure2({
	cashInAdvance,
	minCashInAdvance,
	paymentPlan,
	currency,
	startDate,
	updateFields,
}) {
	// Eğer paymentPlan boşsa, varsayılan olarak bir girişle başlat
	const [inputFields, setInputFields] = useState(
		paymentPlan.length > 0 ? paymentPlan : [{ date: '', amount: 0 }]
	);

	// Sayfa ilk açıldığında en az bir boş alan eklenmesini sağla
	useEffect(() => {
		if (inputFields.length === 0) {
			addField();
		}
	}, []); // Dependency array added to prevent infinite loop

	// Değerleri güncelleyen fonksiyon
	const handleChange = (index, name, value) => {
		const updatedFields = [...inputFields];

		updatedFields[index] = {
			...updatedFields[index],
			[name]: value,
		};

		setInputFields(updatedFields);
		updateFields({ paymentPlan: updatedFields });
	};

	// Yeni obje ekleyerek paymentPlan dizisini güncelle
	const addField = () => {
		const newField = { date: '', amount: 0 };
		const updatedFields = [...inputFields, newField]; // Yeni alanı push ediyoruz
		setInputFields(updatedFields);
		updateFields({ paymentPlan: updatedFields });
	};

	// Alanı kaldırma
	const removeField = (index) => {
		const filteredFields = inputFields.filter((_, i) => i !== index);
		setInputFields(filteredFields);
		updateFields({ paymentPlan: filteredFields });
	};

	return (
		<form className="create" autoComplete="off">
			<h3>Ödeme Planını Oluştur</h3>

			<label>
				Peşin Ödenen:
				{minCashInAdvance > 0 && (
					<span className="min-hint">
						{' '}(en az {formatCurrency(minCashInAdvance, currency)})
					</span>
				)}
			</label>
			<div className="custom-input">
				<input
					type="date"
					name="date"
					value={startDate}
					onChange={(e) => updateFields({ startDate: e.target.value })}
				/>
				<CurrencyInput
					value={cashInAdvance}
					currency={currency}
					onChange={(amount) => updateFields({ cashInAdvance: amount })}
					placeholder='Örn: "10.000"'
				/>

				{inputFields.map((inputField, index) => (
					<div key={index} className="paymentPlanner">
						<input
							type="date"
							name="date"
							value={inputField.date}
							onChange={(e) => handleChange(index, 'date', e.target.value)}
						/>
						<CurrencyInput
							name="amount"
							value={inputField.amount}
							currency={currency}
							onChange={(amount) => handleChange(index, 'amount', amount)}
							placeholder='Örn: "10.000"'
						/>
						<span
							className="material-symbols-outlined"
							id="remove"
							onClick={() => removeField(index)}
						>
							remove
						</span>
						<span
							className="material-symbols-outlined"
							id="add"
							onClick={addField}
						>
							add
						</span>
					</div>
				))}
			</div>
		</form>
	);
}
